import { type WithChildren } from "@client/types/WithChildren";
import { type ButtonsAlign, FormStyleContext, type FormStyleContextProps, type LabelVisibility } from "@common/contexts/FormStyle";
import React from "react";

export type MapProps = WithChildren & {
  buttonsAlign?: ButtonsAlign;
  fieldStyle: React.CSSProperties;
  labelPlacement: "label-inside" | "label-outside-left";
  labelVisibility: LabelVisibility | undefined;
  labelStyle: React.CSSProperties | undefined;
  primaryButtonStyle?: React.CSSProperties;
  secondaryButtonStyle?: React.CSSProperties;
};
export default (props: MapProps) => {
  const value = React.useMemo<FormStyleContextProps>(
    () => ({
      buttonsAlign: props.buttonsAlign,
      fieldStyle: props.fieldStyle,
      labelPosition: props.labelPlacement === "label-inside" ? "inside" : "top",
      labelVisibility: props.labelVisibility,
      labelStyle: props.labelStyle,
      primaryButtonStyle: props.primaryButtonStyle,
      secondaryButtonStyle: props.secondaryButtonStyle
    }),
    [
      props.buttonsAlign,
      props.fieldStyle,
      props.labelPlacement,
      props.labelVisibility,
      props.labelStyle,
      props.primaryButtonStyle,
      props.secondaryButtonStyle
    ]
  );

  return <FormStyleContext.Provider value={value}>{props.children}</FormStyleContext.Provider>;
};
